import { HighDefinitionBoxIcon } from './HighDefinitionBoxIcon';

/**
 * author: Google
 * id BD1F0404-AA98-4FCF-8947-D0589C91A610
 * name high-definition-box
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/high-definition-box.svg
 * tags
 * - Video / Movie 
 */
export const HdBoxIcon = HighDefinitionBoxIcon;
export default HdBoxIcon